import { Box, IconButton, Tooltip } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { colors } from "../../../constants/colors";
import { formatFileSize } from "../../../utils/common";
import { FileRow, MetaLabel, SectionHeading } from "./announceView.style";
import { fileUrl } from "./announceView.utils";

type Props = {
  files: any[];
  /** กดที่ชื่อไฟล์ — ใช้ handlepreview ของหน้าแม่ (แยกเคส pdf กับรูปให้แล้ว) */
  onPreview: (file: any) => void;
  heading?: string;
};

/** รายการไฟล์แนบของประกาศ */
export default function AnnounceFileList({ files, onPreview, heading }: Props) {
  const list = (files || []).filter((e: any) => e?.fileName);
  if (!list.length) return null;

  return (
    <Box sx={{ marginTop: "28px" }}>
      <SectionHeading>{heading || "ไฟล์แนบ"}</SectionHeading>
      {list.map((file: any, index: number) => (
        <FileRow key={file?.fileId || `file-${index}`}>
          <Box
            onClick={() => onPreview(file)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              minWidth: 0,
              cursor: "pointer",
              fontFamily: "Kanit",
              fontSize: "16px",
              color: colors.textPrimary,
              ":hover": { color: colors.themeMainColor },
            }}
          >
            <DescriptionOutlinedIcon
              sx={{ fontSize: 20, color: colors.textLightGray, flexShrink: 0 }}
            />
            <Box sx={{ wordBreak: "break-all" }}>{file?.fileName}</Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexShrink: 0,
            }}
          >
            <MetaLabel sx={{ whiteSpace: "nowrap" }}>
              {formatFileSize(file?.fileSize)}
            </MetaLabel>
            {/* ไฟล์อยู่คนละ origin ตัว download attribute จึงถูกเบราว์เซอร์เมิน
                กรณีนั้นจะกลายเป็นเปิดแท็บใหม่ ซึ่งยังใช้บันทึกไฟล์ต่อได้ */}
            <Tooltip title="ดาวน์โหลดไฟล์">
              <IconButton
                component="a"
                href={fileUrl(file)}
                download={file?.fileName}
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{ color: colors.textLightGray }}
              >
                <DownloadOutlinedIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </FileRow>
      ))}
    </Box>
  );
}
